import format from 'civic-champs-shared/utils/format'
import {
  ARRAY_OPERATOR_OPTIONS,
  DATE_OPERATOR_OPTIONS,
  NUMBER_OPERATOR_OPTIONS,
  operatorTypes,
  STRING_OPERATOR_OPTIONS,
} from 'core/table/interfaces/Filters'

const CHAMPION_DATE_FILTER_COLUMNS = new Set(['latestActivity', 'startedAt', 'birthDate'])

export const championsTableName = 'champions'

type ChampionsSummaryT = (key: string, options?: { defaultValue?: string; valuePerHour?: number }) => string

export const buildChampionsSummaryCards = (valuePerHour: number, t: ChampionsSummaryT) => [
  {
    header: t('pages.champions.summary.champions', { defaultValue: 'Champions' }),
    accessor: 'count',
    transform: format.number,
  },
  {
    header: t('pages.champions.summary.hours', { defaultValue: 'Hours' }),
    accessor: 'totalHours',
    transform: format.number,
  },
  {
    header: t('pages.champions.summary.estimatedImpact', { defaultValue: 'Estimated Impact' }),
    accessor: 'estimatedImpact',
    transform: format.money,
    tooltip: t('pages.champions.summary.estimatedImpactTooltip', {
      defaultValue: `This value was calculated using the national average of $${valuePerHour} / hour for volunteers.`,
      valuePerHour,
    }),
  },
]

/** @deprecated use buildChampionsSummaryCards with useChampionsPageI18n */
export const getChampionsSummaryCards = (valuePerHour: number) =>
  buildChampionsSummaryCards(valuePerHour, (_key, options) => options?.defaultValue ?? '')

export type ChampionsPagedSummaryResponse = {
  count: number
  totalVolunteerHours: number
  totalDonationsCents: number
}

export const buildChampionsHeaderSummary = (
  { count, totalVolunteerHours, totalDonationsCents }: ChampionsPagedSummaryResponse,
  valuePerHour: number,
) => {
  const totalHours = Math.round(totalVolunteerHours * 100) / 100
  const totalDonations = totalDonationsCents / 100
  return {
    count,
    totalHours,
    totalDonations,
    estimatedImpact: valuePerHour * totalHours + totalDonations,
  }
}

export const championsHiddenColumns = [
  'firstName',
  'lastName',
  'email',
  'mobile',
  'homePhoneNumber',
  'expectedContact',
  'address',
  'consolidatedContact',
  'status',
  'startedAt',
  'birthDate',
]

export const getChampionsOperatorOptions = (column: string) => {
  if (CHAMPION_DATE_FILTER_COLUMNS.has(column)) {
    return DATE_OPERATOR_OPTIONS
  }
  switch (column) {
    case 'firstName':
    case 'lastName':
    case 'email':
    case 'mobile':
    case 'name':
    case 'homePhoneNumber':
      return STRING_OPERATOR_OPTIONS

    case 'hours':
    case 'donations':
      return NUMBER_OPERATOR_OPTIONS
    case 'groups':
    case 'tags':
      return ARRAY_OPERATOR_OPTIONS
    case 'status':
    case 'expectedContact':
      return [
        { value: operatorTypes.ANY_OF, displayValue: 'Includes' },
        { value: operatorTypes.NOT_ANY_OF, displayValue: 'Does not include' },
      ]
    default:
      return []
  }
}
